module.exports = __webpack_public_path__ + "img/num_layout_06.507d7756.png";